import { render, staticRenderFns } from "./DelaysSettings.vue?vue&type=template&id=2794342e"
import script from "./DelaysSettings.vue?vue&type=script&lang=js"
export * from "./DelaysSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports